import {datasource} from 'alt-utils/lib/decorators';
import {seamlessImmutable, seamlessBootstrap} from 'epic-alt-utils';
import FriendInviteActions from 'epic-fortnite-react/actions/FriendInviteActions';
import alt from 'epic-fortnite-react/alt';
import Immutable from 'seamless-immutable';

import FriendInviteSource from '../sources/FriendInviteSource';

@datasource(FriendInviteSource)
@seamlessImmutable
class FriendInviteStore {
  constructor() {
    this.on('error', (error) => {
      console.error(error);
    });
    this.on('bootstrap', seamlessBootstrap.bind(this, null));
    this.state = Immutable({
      friendInvite: {},
      inviteResponse: null,
      enableModal: false,
      loading: false,
      error: null,
    });
    this.bindActions(FriendInviteActions);
  }

  //toggle modal function
  onShowModal() {
    this.setState(
      this.state.merge({
        enableModal: true,
      })
    );
  }

  //toggle modal function
  onHideModal() {
    this.setState(
      this.state.merge({
        enableModal: false,
      })
    );
  }

  onSendInvite({friendId, platform}) {
    if (this.state.loading) {
      return false;
    }
    this.getInstance().sendInvite(friendId, platform);
    return this.setState(this.state.set('loading', true));
  }

  onSendInviteSuccess(response) {
    const newState = {
      loading: false,
      inviteResponse: response.data,
      error: null,
    };
    this.setState(this.state.merge(newState));
  }

  onSendInviteFailure(response) {
    console.error('Failed to send friend invite.');
    const error = response.data && response.data.message;
    this.setState(
      this.state.merge({
        loading: false,
        error,
      })
    );
  }
}

export default alt.createStore(FriendInviteStore, 'FriendInviteStore');
